// A value axis (`left` always; `right` only when a series binds it).
// Renders the real recharts axis opposite the category axis, with the
// number scale + side-correct title. The model decides which physical
// axis is the value axis (the inverse of the category axis).

import { XAxis, YAxis } from 'recharts';

import { AXIS_CHROME, bottomTitle, sideTitle } from './axisLabels.tsx';
import type { ChartOrientation } from './chartOrientation.ts';

export function ValueAxis({
  o,
  side,
  title,
  unit,
  tickFormatter,
}: {
  o: ChartOrientation;
  side: 'left' | 'right';
  title: string | undefined;
  /** Declared unit for the series on this axis — rendered as a dimmed suffix on the title. */
  unit: string | undefined;
  tickFormatter: (value: number) => string;
}) {
  const common = {
    ...AXIS_CHROME,
    tickFormatter,
    type: 'number' as const,
    width: 'auto' as const,
  };
  // The value axis is the X axis exactly when the category axis is a
  // side (Y) axis — i.e. the inverse of `categoryIsBottom`.
  return o.categoryIsBottom ? (
    <YAxis {...common} label={sideTitle(title, side, unit)} orientation={side} yAxisId={side} />
  ) : (
    <XAxis {...common} label={bottomTitle(title, unit)} xAxisId={side} />
  );
}
